export const ITEM_STATUSES = [
    "PRINTED",
    "IN_STOCK",
    "PICKED",
    "PACKED",
    "SHIPPED",
    "RETURNED",
    "VOIDED",
    "FROZEN",
];
export const ROLE_CODES = ["OPERATOR", "SUPERVISOR", "ADMIN"];
export const ROLE_LABEL = {
    OPERATOR: "作业员",
    SUPERVISOR: "主管",
    ADMIN: "管理员",
};
export const ITEM_STATUS_LABEL = {
    PRINTED: "待入库",
    IN_STOCK: "待上架",
    PICKED: "待上架",
    PACKED: "已复核",
    SHIPPED: "已出库",
    RETURNED: "已退回",
    VOIDED: "已作废",
    FROZEN: "已冻结",
};
export function unitStatusText(status, locationCode) {
    if (status === "PRINTED")
        return "待入库";
    if (status === "IN_STOCK" || status === "PICKED")
        return locationCode ? "可用" : "待上架";
    return ITEM_STATUS_LABEL[status];
}
export const ITEM_STATUS_COLOR = {
    PRINTED: "default",
    IN_STOCK: "processing",
    PICKED: "processing",
    PACKED: "cyan",
    SHIPPED: "success",
    RETURNED: "warning",
    VOIDED: "error",
    FROZEN: "error",
};
/** 存下来的库位码：面和架号贴在一起，层和位有才出现。例如 A1、A9-1、A1-2-3。 */
export const LOCATION_CODE_PATTERN = /^[A-Z][1-9]\d?(?:-[1-9]\d?){0,2}$/;
export const DIGIT8_PATTERN = /^\d{8}$/;
export const PASS_MESSAGE = "这双已复核。请继续扫下一双。";
export const PEEL_HINT = "请撕下外标，贴入外箱内侧襟翼，确保鞋盒外表干净合规";
//# sourceMappingURL=index.js.map